export const SIDO_LIST = [
  {
    label: '전국',
    code: '00',
  },
  {
    label: '서울특별시',
    code: '11',
  },
  {
    label: '부산광역시',
    code: '26',
  },
  {
    label: '대구광역시',
    code: '27',
  },
  {
    label: '인천광역시',
    code: '28',
  },
  {
    label: '광주광역시',
    code: '29',
  },
  {
    label: '대전광역시',
    code: '30',
  },
  {
    label: '울산광역시',
    code: '31',
  },
  {
    label: '세종특별자치시',
    code: '36',
  },
  {
    label: '경기도',
    code: '41',
  },
  {
    label: '강원도',
    code: '42',
  },
  {
    label: '충청북도',
    code: '43',
  },
  {
    label: '충청남도',
    code: '44',
  },
  {
    label: '전라북도',
    code: '45',
  },
  {
    label: '전라남도',
    code: '46',
  },
  {
    label: '경상북도',
    code: '47',
  },
  {
    label: '경상남도',
    code: '48',
  },
  {
    label: '제주특별자치도',
    code: '50',
  },
];

export const SHORT_SIDO_NAME: Record<string, string> = {
  '00': '전국',
  '11': '서울',
  '26': '부산',
  '27': '대구',
  '28': '인천',
  '29': '광주',
  '30': '대전',
  '31': '울산',
  '36': '세종',
  '41': '경기',
  '42': '강원',
  '43': '충북',
  '44': '충남',
  '45': '전북',
  '46': '전남',
  '47': '경북',
  '48': '경남',
  '50': '제주',
};
